import { TrailerEdit } from "./TrailerEdit";
import { TrailerCreate } from "./TrailerCreate";
import { TrailersList } from "./../trailers/TrailersList";
import TrailerOutlineIcon from "../../../common/icons/TrailerOutlineIcon";

export default {
  icon: TrailerOutlineIcon,
  list: TrailersList,
  create: TrailerCreate,
  edit: TrailerEdit,
};
